module.exports = __webpack_public_path__ + "static/media/logo.7c82fa74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 72
// module chunks = 0